module.exports = __webpack_public_path__ + "static/media/icon-important.c7660b55.svg";